module.exports = __webpack_public_path__ + "img/closeIcon.3ceb008d.svg";